import './userManual.scss';

import React from 'react';
import {useTranslation} from 'react-i18next';
import {UserManualModal} from '../common/hibuModal/hibuModal';

type UserManualProps = {
    showUserManual: boolean;
    onClose: () => void;
}

export const UserManual = React.memo(({showUserManual, onClose}: UserManualProps) => {
    const {t} = useTranslation();

    const onHide = () => {
        onClose();
    };

    return (
        <div style={{visibility: 'collapse'}}>
            <UserManualModal
                show={showUserManual}
                onHide={onHide}
                cancel={t('general.close')}
                formId={'xxx'}
            >
                <iframe
                    src={process.env.REACT_APP_MANUAL_URL ?? '/manual/'}
                    title="My great User Manual"
                    className="user-manual-iframe"
                />
            </UserManualModal>
        </div>
    );
});
